export const CONVERSATION_REALTIME_EVENT = 'conversation:update';

export type ConversationRealtimeEvent = {
  conversationId: number;
  messageId?: number | null;
  kind:
    | 'message_created'
    | 'delivery_status_changed'
    | 'read_state_changed'
    | 'automation_state_changed';
};
